<template>
  <div id='not-found' class='container'>
    <div class='row justify-content-center'>
      <h1>
        404! Page not found!
      </h1>
    </div>
  </div>

</template>

<script>

export default {
  name: 'NotFound'
}
</script>

<style scoped>

.valid {
    color: green;
}
.valid:before {
    content: "✔";
}
.invalid {
    color: red;
}
.invalid:before {
    content: "✖";
}
#not-found {
  width: 500px;
  border-radius: 5px;
  background-color: #de0d0d;
  margin: auto;
  margin-top: 200px;
  padding: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue